export function activeLayers<K extends string, T>(item: [K, T])
{
    const enabledLayers = getEnabledLayers();
    const [key] = item;

    if (key.startsWith('/'))
        return true;

    for (const layer of enabledLayers)
    {
        // `../layers/` to klucze globów bez `base` (stary format, warstwy klienckie), `./layers/` z `base` (nowa forma rdzenia)
        if (key.startsWith(`../layers/${layer}`) || key.startsWith(`./layers/${layer}`))
            return true;
    }

    return false;
};

export function getEnabledLayers()
{
    const config = useRuntimeConfig();

    return (config.public.layers || '')
        .split(',')
        .map(layer => layer.trim())
        .filter(Boolean);
}

export function isLayerEnabled(layer: string)
{
    return getEnabledLayers().includes(layer);
}
